import * as React from 'react';
import { TimeKeeperAssignment } from '../api/types/types';

export const TKContext = React.createContext<TimeKeeperAssignment | null>(null);
export const TKProvider = TKContext.Provider;
export const TKConsumer = TKContext.Consumer;